import React from 'react';
import { Search, X } from 'lucide-react';

/**
 * <Toolbar search={search} onSearch={setSearch}
 *          filters={<>...</>}
 *          actions={<button>Export</button>} />
 */
const Toolbar = ({ search, onSearch, placeholder = 'Search…', filters, actions }) => (
    <div className="flex flex-wrap items-center gap-2.5 mb-5">
        {onSearch && (
            <div className="relative flex-1 min-w-[220px] max-w-sm">
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-neutral-400 pointer-events-none" />
                <input
                    type="text"
                    value={search || ''}
                    onChange={e => onSearch(e.target.value)}
                    placeholder={placeholder}
                    className="input pl-9 pr-8"
                />
                {search && (
                    <button
                        type="button"
                        onClick={() => onSearch('')}
                        className="absolute right-2.5 top-2.5 text-neutral-400 hover:text-neutral-600 p-0.5 rounded-full hover:bg-neutral-100 transition-colors"
                        title="Clear search"
                    >
                        <X className="h-3.5 w-3.5" />
                    </button>
                )}
            </div>
        )}
        {filters && <div className="flex flex-wrap items-center gap-2">{filters}</div>}
        <div className="ml-auto flex items-center gap-2">{actions}</div>
    </div>
);

export default Toolbar;
